import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineLargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_LARGE_OUTLINE_BUTTONS, EDGE_LARGE_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeOutlineLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineLargeButton} span={EDGE_LARGE_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" outline color="primary" id="Tooltip-54" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-54" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-lg</ToolTip>
          {EDGE_LARGE_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} outline size="lg"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeOutlineLargeButtons;
